export interface SearchFilterParams {
    fieldName: string;
    fieldValue: any;
    operator: string;
}

export interface SortFilterParam {
    fieldName: string
    direction: string
}

export interface SearchParam {
    filters?: SearchFilterParams[];
    sorting?: SortFilterParam[];
    limit?: number;
    from?: number;
    q?: string;
}

export enum SEARCH_SCOPES {
    PRIVATE,
    SHARED,
    SCHOOL,
    DEPARTMENT,
    PUBLIC,

}
